
<div class="delegation-dialog">
  <div class="delegation-header">
    <div class="delegation-header-icon">
      <i class="pi pi-user-plus"></i>
    </div>

    <div class="delegation-header-content">
      <h2>Nuovo iscritto con delega</h2>
      <p>Compila i dati dell'iscritto per procedere alla creazione della delega sindacale.</p>
    </div>

    <button
      type="button"
      class="delegation-close"
      aria-label="Chiudi"
      (click)="cancel()"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  <form [formGroup]="formGroup" class="delegation-form">
    <div class="delegation-body">

      <!-- DATI ANAGRAFICI -->
      <section class="delegation-section">
        <div class="section-heading">
          <div class="section-icon">
            <i class="pi pi-user"></i>
          </div>
          <div>
            <h3>Dati anagrafici</h3>
            <p>Informazioni personali del nuovo iscritto</p>
          </div>
        </div>

        <div class="fields-grid">
          <div class="form-field">
            <label for="delegation-name">Nome <span class="required">*</span></label>
            <input
              id="delegation-name"
              type="text"
              pInputText
              formControlName="name"
              [(ngModel)]="newSubscriber.name"
              placeholder="Inserisci il nome"
            />
          </div>

          <div class="form-field">
            <label for="delegation-lastName">Cognome <span class="required">*</span></label>
            <input
              id="delegation-lastName"
              type="text"
              pInputText
              formControlName="lastName"
              [(ngModel)]="newSubscriber.lastName"
              placeholder="Inserisci il cognome"
            />
          </div>

          <div class="form-field">
            <label for="delegation-birthDate">Data di nascita <span class="required">*</span></label>
            <p-calendar
              inputId="delegation-birthDate"
              styleClass="delegation-calendar"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [showButtonBar]="true"
              formControlName="birthDate"
              [(ngModel)]="newSubscriber.birthDate"
              appendTo="body"
            ></p-calendar>
          </div>

          <div class="form-field">
            <label for="delegation-birthPlace">Comune di nascita <span class="required">*</span></label>
            <input
              id="delegation-birthPlace"
              type="text"
              pInputText
              formControlName="birthPlace"
              [(ngModel)]="newSubscriber.birthPlace"
              placeholder="Comune di nascita"
            />
          </div>

          <div class="form-field">
            <label for="delegation-birthCity">Provincia di nascita <span class="required">*</span></label>
            <input
              id="delegation-birthCity"
              type="text"
              pInputText
              formControlName="birthCity"
              [(ngModel)]="newSubscriber.birthCity"
              placeholder="Es. PT"
            />
          </div>

          <div class="form-field">
            <label for="delegation-fiscalCode">Codice fiscale <span class="required">*</span></label>
            <input
              id="delegation-fiscalCode"
              type="text"
              pInputText
              formControlName="fiscalCode"
              [(ngModel)]="newSubscriber.fiscalCode"
              placeholder="Inserisci il codice fiscale"
              class="uppercase-input"
              maxlength="16"
            />
          </div>
        </div>
      </section>

      <!-- RESIDENZA -->
      <section class="delegation-section">
        <div class="section-heading">
          <div class="section-icon">
            <i class="pi pi-map-marker"></i>
          </div>
          <div>
            <h3>Residenza</h3>
            <p>Indirizzo e località di residenza</p>
          </div>
        </div>

        <div class="fields-grid">
          <div class="form-field">
            <label for="delegation-residentPlace">Comune di residenza <span class="required">*</span></label>
            <input
              id="delegation-residentPlace"
              type="text"
              pInputText
              formControlName="residentPlace"
              [(ngModel)]="newSubscriber.residentPlace"
              placeholder="Comune di residenza"
            />
          </div>

          <div class="form-field">
            <label for="delegation-residentCity">Provincia di residenza <span class="required">*</span></label>
            <input
              id="delegation-residentCity"
              type="text"
              pInputText
              formControlName="residentCity"
              [(ngModel)]="newSubscriber.residentCity"
              placeholder="Es. PT"
            />
          </div>

          <div class="form-field full-width">
            <label for="delegation-residentAddress">Indirizzo e numero civico <span class="required">*</span></label>
            <input
              id="delegation-residentAddress"
              type="text"
              pInputText
              formControlName="residentAddress"
              [(ngModel)]="newSubscriber.residentAddress"
              placeholder="Via, piazza e numero civico"
            />
          </div>
        </div>
      </section>

      <!-- DATI AZIENDALI -->
      <section class="delegation-section">
        <div class="section-heading">
          <div class="section-icon">
            <i class="pi pi-briefcase"></i>
          </div>
          <div>
            <h3>Dati aziendali</h3>
            <p>Informazioni relative al rapporto di lavoro</p>
          </div>
        </div>

        <div class="fields-grid">
          <div class="form-field">
            <label for="delegation-headquarter">Sede aziendale <span class="required">*</span></label>
            <input
              id="delegation-headquarter"
              type="text"
              pInputText
              formControlName="headquarter"
              [(ngModel)]="newSubscriber.headquarter"
              placeholder="Inserisci la sede aziendale"
            />
          </div>

          <div class="form-field">
            <label for="delegation-registerNumber">Matricola aziendale <span class="required">*</span></label>
            <input
              id="delegation-registerNumber"
              type="text"
              pInputText
              formControlName="registerNumber"
              [(ngModel)]="newSubscriber.registerNumber"
              placeholder="Numero di matricola"
            />
          </div>

          <div class="form-field">
            <label for="delegation-sector">Impianto aziendale <span class="required">*</span></label>
            <p-autoComplete
              inputId="delegation-sector"
              styleClass="delegation-autocomplete"
              formControlName="sector"
              [(ngModel)]="newSubscriber.sector"
              [dropdown]="true"
              [suggestions]="filteredSectors"
              (completeMethod)="filterSector($event)"
              [multiple]="false"
              appendTo="body"
              placeholder="Seleziona un impianto"
            ></p-autoComplete>
          </div>

          <div class="form-field">
            <label for="delegation-contract">Contratto <span class="required">*</span></label>
            <input
              id="delegation-contract"
              type="text"
              pInputText
              formControlName="contract"
              [(ngModel)]="newSubscriber.contract"
              placeholder="Contratto aziendale"
            />
          </div>

          <div class="form-field">
            <label for="delegation-typeContract">Tipo contratto <span class="required">*</span></label>
            <p-autoComplete
              inputId="delegation-typeContract"
              styleClass="delegation-autocomplete"
              formControlName="typeContract"
              [(ngModel)]="newSubscriber.typeContract"
              [dropdown]="true"
              [suggestions]="filteredTypeContracts"
              (completeMethod)="filterTypeContract($event)"
              [multiple]="false"
              appendTo="body"
              placeholder="Seleziona il tipo contratto"
            ></p-autoComplete>
          </div>
        </div>
      </section>

      <!-- CONTATTI -->
      <section class="delegation-section">
        <div class="section-heading">
          <div class="section-icon">
            <i class="pi pi-envelope"></i>
          </div>
          <div>
            <h3>Recapiti</h3>
            <p>Contatti del nuovo iscritto</p>
          </div>
        </div>

        <div class="fields-grid">
          <div class="form-field">
            <label for="delegation-email">Email <span class="required">*</span></label>
            <input
              id="delegation-email"
              type="email"
              pInputText
              formControlName="email"
              [(ngModel)]="newSubscriber.email"
              placeholder="nome@esempio.it"
            />
          </div>

          <div class="form-field">
            <label for="delegation-phone">Telefono <span class="required">*</span></label>
            <input
              id="delegation-phone"
              type="tel"
              pInputText
              formControlName="phone"
              [(ngModel)]="newSubscriber.phone"
              placeholder="Numero di telefono"
            />
          </div>
        </div>
      </section>

      <!-- FIRMA -->
      <section class="delegation-section signature-section">
        <div class="section-heading">
          <div class="section-icon">
            <i class="pi pi-pencil"></i>
          </div>
          <div>
            <h3>Firma dell'iscritto</h3>
            <p>Scegli lo stile della firma che verrà riportata sulla delega</p>
          </div>
        </div>

        <div class="signature-content">
          <label class="signature-label">Stile della firma</label>

          <div class="signature-font-selector">
            <p-selectButton
              [options]="availableFonts"
              [(ngModel)]="selectedFont"
              [ngModelOptions]="{ standalone: true }"
              [allowEmpty]="false"
            ></p-selectButton>
          </div>

          <div class="signature-preview">
            <div class="signature-preview-label">
              <i class="pi pi-eye"></i>
              Anteprima firma
            </div>

            <div class="signature-preview-content">
              <div
                class="signature-text"
                [ngClass]="selectedFont"
              >
                {{ newSubscriber.name || 'Nome' }}
                {{ newSubscriber.lastName || 'Cognome' }}
              </div>
            </div>

            <div class="signature-preview-footer">
              <i class="pi pi-info-circle"></i>
              La firma verrà inserita nel documento di delega.
            </div>
          </div>
        </div>
      </section>

    </div>

    <!-- FOOTER -->
    <div class="delegation-footer">
      <div class="footer-hint">
        <i class="pi pi-info-circle"></i>
        <span>I campi contrassegnati con * sono obbligatori.</span>
      </div>

      <div class="footer-actions">
        <p-button
          label="Annulla"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          (onClick)="cancel()"
        ></p-button>

        <p-button
          label="Continua"
          icon="pi pi-arrow-right"
          iconPos="right"
          [disabled]="!formGroup.valid"
          (onClick)="showConfirm()"
        ></p-button>
      </div>
    </div>
  </form>
</div>